import { useSyncExternalStore } from 'react';

/** Viewport at which the sidebar leaves the grid and becomes a drawer (the top-bar hamburger opens it). */
export const NARROW_QUERY = '(max-width: 1000px)';

const subscribe = (query: string) => (onChange: () => void) => {
  const mql = window.matchMedia(query);
  mql.addEventListener('change', onChange);
  return () => {
    mql.removeEventListener('change', onChange);
  };
};

/** True when the media query matches; re-renders on change. Safe without matchMedia (returns false). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    subscribe(query),
    () => window.matchMedia(query).matches,
    () => false,
  );
}
